import * as React from 'react'

/**
 * Generic user/avatar glyph (head + shoulders), matching the navbar design
 * handoff's placeholder avatar. The app has no per-user avatar image, so this
 * stands in everywhere an avatar appears — desktop sidebar header, mobile top
 * bar, drawer user row, and account menu.
 *
 * Uses `currentColor` so the surrounding circle's `color` tints it (the design
 * uses a light `#cfe0ff` on a translucent navy circle). Size is controlled by
 * the parent via `svg { width/height }`, so the same glyph fits each container.
 */
const UserGlyph: React.FC = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="8.5" r="3.6" />
        <path d="M5.5 20a6.5 6.5 0 0 1 13 0" />
    </svg>
)

export default UserGlyph
